import { createGlobalStyle } from 'styled-components';

import breakpoints from '@rsc/ui-components/breakpoints';
import sharedStyles from '@rsc/ui-components/styles';

export const GlobalStyles = createGlobalStyle`

  @font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/e3ed45/00000000000000007735e602/30/l?subset_id=2&fvd=n9&v=3") format("woff2"),
      url("https://use.typekit.net/af/e3ed45/00000000000000007735e602/30/d?subset_id=2&fvd=n9&v=3") format("woff"),
      url("https://use.typekit.net/af/e3ed45/00000000000000007735e602/30/a?subset_id=2&fvd=n9&v=3") format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: ${sharedStyles.fontWeight.black};
    font-stretch: normal;
    font-display: swap
  }
  @font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/2555e1/00000000000000007735e603/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),
      url("https://use.typekit.net/af/2555e1/00000000000000007735e603/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),
      url("https://use.typekit.net/af/2555e1/00000000000000007735e603/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: ${sharedStyles.fontWeight.bold};
    font-stretch: normal;
    font-display: swap
  }
  @font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/4de20a/00000000000000007735e604/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),
      url("https://use.typekit.net/af/4de20a/00000000000000007735e604/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),
      url("https://use.typekit.net/af/4de20a/00000000000000007735e604/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
    font-display: auto;
    font-style: italic;
    font-weight: ${sharedStyles.fontWeight.bold};
    font-stretch: normal;
    font-display: swap
  }
  @font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/efe4a5/00000000000000007735e609/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),
      url("https://use.typekit.net/af/efe4a5/00000000000000007735e609/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),
      url("https://use.typekit.net/af/efe4a5/00000000000000007735e609/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: ${sharedStyles.fontWeight.regular};
    font-stretch: normal;
    font-display: swap
  }
  @font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/3322cc/00000000000000007735e616/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff2"),
      url("https://use.typekit.net/af/3322cc/00000000000000007735e616/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff"),
      url("https://use.typekit.net/af/3322cc/00000000000000007735e616/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("opentype");
    font-display: auto;
    font-style: italic;
    font-weight: ${sharedStyles.fontWeight.regular};
    font-stretch: normal;
    font-display: swap
  }
  @font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/154cda/00000000000000007735e601/30/l?subset_id=2&fvd=n1&v=3") format("woff2"),
      url("https://use.typekit.net/af/154cda/00000000000000007735e601/30/d?subset_id=2&fvd=n1&v=3") format("woff"),
      url("https://use.typekit.net/af/154cda/00000000000000007735e601/30/a?subset_id=2&fvd=n1&v=3") format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: ${sharedStyles.fontWeight.thin};
    font-stretch: normal;
    font-display: swap
  }

  html, body {
    font-size: ${sharedStyles.fontSize.base};
    font-family: "proxima-nova", sans-serif;
    font-weight: ${sharedStyles.fontWeight.regular};
    line-height: 1.5;
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.defaultFont};
    text-rendering: optimizeLegibility;
    background: ${({ theme }) => theme.colors.background};
  }

  body {
    scroll-behavior: smooth;
  }

  *, *::before, *::after {
    box-sizing: inherit;
    line-height: inherit;
  }

  /* this is needed to make styled inputs work on Safari 🤷
  https://stackoverflow.com/questions/49889003/cannot-write-into-input-field-on-safari */
  input, input:before, input:after {
    -webkit-user-select: initial;
    -khtml-user-select: initial;
    -moz-user-select: initial;
    -ms-user-select: initial;
    user-select: initial;
  }

  // Add scroll margin = to Navigation Banner height, to fix sticky banner
  // Being on top of anchor tag.
  h1, h2, h3, h4, h5, h6,
  div[id^=section-id-] {
    scroll-margin-top: 32px;
  }

  a {
    color: ${({ theme }) => theme.colors.link};

    &:hover {
      text-decoration: none;
    }
  }

  p {
    margin: 0 0 1em;
  }

  h1, h2, h3, h4, h5, h6 {
    line-height: 1.15;
    margin: 0 0 0.25em;
    color: ${({ theme }) => theme.colors.headline};
  }

  blockquote {
    color: ${({ theme }) => theme.colors.headline};
  }

  strong {
    font-style: inherit;
    font-weight: ${({ theme }) => theme.colors.background};
  }

  sup {
    top: revert;
    vertical-align: super;
    font-size: 75%;
  }

  ol {
    list-style-type: decimal;
    margin-left: ${sharedStyles.spacing['spacing-md']};

    @media screen and (min-width: ${breakpoints.md}){
      margin-left: 0;
    }
  }

  ol li {
    margin-bottom: ${sharedStyles.spacing['spacing-md']};
  }

  input, select, textarea {
    background-color: #ffffff;
    border: 1px solid ${({ theme }) => theme.colors.border};
    font-family: inherit;
  }

  #hubspot-messages-iframe-container { z-index: 9990!important; }

  .aspect-video {
    @supports not (aspect-ratio: 16 / 9) {
      &::before {
        float: left;
        padding-top: 56.25%;
        content: '';
      }
      &::after {
        display: block;
        content: '';
        clear: both;
      }
    }
  }
`;

export default GlobalStyles;
